import apiService from './api';

export interface StoreClientPolicy {
  storeSafeMode: boolean;
  minSupportedShellVersion: string;
  forceStorePurchaseLockdown: boolean;
}

let loaded = false;

function parseVersion(value: string): number[] {
  return value.split('.').map((part) => Number.parseInt(part, 10) || 0);
}

function isOlderVersion(current: string | null, minimum: string): boolean {
  if (!current || !minimum) return false;
  const a = parseVersion(current);
  const b = parseVersion(minimum);
  const len = Math.max(a.length, b.length);
  for (let i = 0; i < len; i += 1) {
    const left = a[i] ?? 0;
    const right = b[i] ?? 0;
    if (left < right) return true;
    if (left > right) return false;
  }
  return false;
}

export async function loadStoreClientPolicy(): Promise<StoreClientPolicy | null> {
  if (loaded) return null;
  loaded = true;
  try {
    const policy = await apiService.get<StoreClientPolicy>('/api/config/store-client-policy');
    if (typeof window !== 'undefined') {
      if (policy.storeSafeMode) {
        window.__QIXIT_STORE_SAFE_MODE__ = true;
      }
      const shellVersion = window.__QIXIT_SHELL_VERSION__?.trim() || null;
      if (isOlderVersion(shellVersion, policy.minSupportedShellVersion)) {
        window.__QIXIT_STORE_SAFE_MODE__ = true;
      }
    }
    return policy;
  } catch {
    return null;
  }
}
